import React, { useState, useEffect } from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { useSnackbar } from 'notistack';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import { AdminSvc } from '@/Services';


import {
  Formik,
  Form,
  useField,
  Field,
  ErrorMessage,
  validateYupSchema,
} from 'formik';
import * as Yup from 'yup';
import {
  RightDrawer,
  DrawerForm,
  FormButton,
  FormTextField,
  InputField,
  DrawerCardContent,
  DrawerCardActions,
  FormMenuItem,
} from '@/Theme';
import { Refresh } from '@mui/icons-material';
import { MenuItem } from '@mui/material';

const Edit = ({ openDrawer, setOpenDrawer, panelId, testType, success }) => {
  console.log('### Selected item for edit: ', testType);
  const [organizations, setOrganizations] = useState([]);
  const [selectedItem, setSelectedItem] = useState(testType);
  const { enqueueSnackbar } = useSnackbar();

  const fetchOrganizations = async () => {
    let response = await AdminSvc.searchOrganizations();
    if (response && response.data) {
      setOrganizations(response.data);
    }
  };

  const handleSuccess = (savedTestType) => {
    setOpenDrawer(false);
    success(savedTestType.data);
  };
  const handleCancel = () => {
    setOpenDrawer(false);
  };
  const initValues = () => {
    return {
      id: selectedItem.id,
      code: selectedItem.code || '',
      name: selectedItem.name || '',
      description: selectedItem.description || '',
      displayName: selectedItem.displayName || '',
      displayDescription: selectedItem.displayDescription || '',
      organizationId: (selectedItem.organization ? selectedItem.organization.id : ''),
      externalId: selectedItem.externalId || '',
      wixId: selectedItem.wixId || '',
      weight: selectedItem.weight || 0,
      active: selectedItem.active !== 'undefined' ? selectedItem.active : true,
    };
  };
  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    code: Yup.string().required('Code is required'),
    description: Yup.string(),
    displayName: Yup.string(),
    organization: Yup.string(),
    displayDescription: Yup.string(),
    weight: Yup.number().required('Weight is required').moreThan(0),
    externalId: Yup.string(),
    wixId: Yup.string(),
    active: Yup.boolean(),
  });
  useEffect(() => {
    fetchOrganizations();
  }, []);
  const form = () => {
    return (
      <Formik
        initialValues={initValues()}
        onSubmit={async (values, { setSubmitting }) => {
          console.log('##### save', values, panelId);
          validationSchema
            .validate(values)
            .then(async (valid) => {
              if (valid) {
                let savedPanel = await AdminSvc.saveKit({
                  id: selectedItem.id,
                  name: values.name,
                  code: values.code,
                  description: values.description,
                  displayName: values.displayName,
                  displayDescription: values.displayDescription,
                  organizationId: values.organizationId,
                  duration: values.duration,
                  weight: values.weight,
                  active: values.active,
                  isPanel: values.isPanel,
                  externalId: values.externalId,
                  wixId: values.wixId
                });

                if (savedPanel) {
                  enqueueSnackbar('Panel saved.', { variant: 'success' });
                  setSelectedItem(savedPanel);
                  handleSuccess(savedPanel);
                }
              }
            })
            .catch((err) => {
              console.log(err.errors);
              enqueueSnackbar(err.errors, { variant: 'error' });
            });
        }}
      >
        {(props) => {
          const {
            values,
            touched,
            errors,
            dirty,
            isSubmitting,
            handleChange,
            handleBlur,
            handleSubmit,
            handleReset,
            setFieldValue,
          } = props;
          const handleChecked = (value) => {
            setFieldValue('active', value);
          };
          return (
            <DrawerForm onSubmit={handleSubmit} autoComplete='nope'>
              <DrawerCardContent>
                <InputField
                  field='organizationId'
                  label='Organization'
                  value={values.organization}
                  props={props}
                  select
                >
                  {organizations.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.name}
                    </MenuItem>
                  ))}
                </InputField>
                <InputField field='name' label='Name' required props={props} />
                <InputField field='code' label='SKU' required props={props} inputProps={{ maxLength: 5 }}/>
                <InputField
                  field='weight'
                  label='Weight (oz)'
                  type='number'
                  required
                  props={props}
                />
                <InputField
                  field='description'
                  label='Description'
                  multiline
                  rows={2}
                  props={props}
                />
                <InputField field='displayName' label='Display Name'  props={props} />
                <InputField
                  field='displayDescription'
                  label='Display Description'
                  multiline
                  rows={2}
                  props={props}
                />
                <InputField
                  field='externalId'
                  label='External ID'
                  props={props}
                  required
                />
                <InputField
                  field='wixId'
                  label='Wix ID'
                  props={props}
                  required
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      name='active'
                      value={values.active}
                      checked={values.active}
                      onChange={() => handleChecked(!values.active)}
                    />
                  }
                  label='Active'
                />
              </DrawerCardContent>
              <DrawerCardActions>
                <FormButton primary type='submit'>
                  Save
                </FormButton>
                <FormButton onClick={handleCancel}>Cancel</FormButton>
              </DrawerCardActions>
            </DrawerForm>
          );
        }}
      </Formik>
    );
  };
  return (
    <div>
      <RightDrawer
        title={selectedItem.id ? 'Edit Lab Kit' : 'Add New Lab Kit'}
        handleClose={handleCancel}
        open={openDrawer}
      >
        {form()}
      </RightDrawer>
    </div>
  );
};
export default Edit;
